export const brands = {
  Audi: 'audi',
  Seat: 'seat',
  Skoda: 'skoda',
  Volkswagen: 'volkswagen',
  VwBedrijfswagens: 'vwbedrijfswagens',
  Cupra: 'cupra',
}

const brandsToCssFileMap = new Map()
brandsToCssFileMap.set(brands.Audi, 'audi')
brandsToCssFileMap.set(brands.Seat, 'seat')
brandsToCssFileMap.set(brands.Skoda, 'skoda')
brandsToCssFileMap.set(brands.Volkswagen, 'volkswagen')
brandsToCssFileMap.set(brands.VwBedrijfswagens, 'bedrijfswagens')
brandsToCssFileMap.set(brands.Cupra, 'cupra')

const brandsToBrandCodeMap = new Map()
brandsToBrandCodeMap.set(brands.Audi, 'a')
brandsToBrandCodeMap.set(brands.Seat, 's')
brandsToBrandCodeMap.set(brands.Skoda, 'c')
brandsToBrandCodeMap.set(brands.Volkswagen, 'v')
brandsToBrandCodeMap.set(brands.VwBedrijfswagens, 'n')
brandsToBrandCodeMap.set(brands.Cupra, 's')

const brandsToPrimaBrandNameMap = new Map()
brandsToPrimaBrandNameMap.set(brands.Audi, 'Audi')
brandsToPrimaBrandNameMap.set(brands.Seat, 'Seat')
brandsToPrimaBrandNameMap.set(brands.Skoda, 'Skoda')
brandsToPrimaBrandNameMap.set(brands.Volkswagen, 'Volkswagen')
brandsToPrimaBrandNameMap.set(brands.VwBedrijfswagens, 'Volkswagen Bedrijfswagens')
brandsToPrimaBrandNameMap.set(brands.Cupra, 'Cupra')

const brandsToBrandFolderMap = new Map()
brandsToBrandFolderMap.set(brands.Audi, 'audi')
brandsToBrandFolderMap.set(brands.Seat, 'seat')
brandsToBrandFolderMap.set(brands.Skoda, 'skoda')
brandsToBrandFolderMap.set(brands.Volkswagen, 'vwpkw')
brandsToBrandFolderMap.set(brands.VwBedrijfswagens, 'vwlkw')
brandsToBrandFolderMap.set(brands.Cupra, 'cupra')

export const getBrandName = () => {
  const location = window.location.hostname
  for (const index of Object.keys(brands)) {
    const brand = brands[index]
    if (location.includes(brand)) {
      return brand
    } else if (location.includes('localhost')) return brands.Volkswagen
  }
  return null
}

export const getCssFileName = () => {
  const brand = getBrandName()
  return brandsToCssFileMap.get(brand)
}

export const getBrandCode = () => {
  const brand = getBrandName()
  return brandsToBrandCodeMap.get(brand)
}

export const getPrimaBrandName = () => {
  const brand = getBrandName()
  return brandsToPrimaBrandNameMap.get(brand)
}

export const getBrandFolder = () => {
  const brand = getBrandName()
  return brandsToBrandFolderMap.get(brand)
}

export const brandIsBwg = () => {
  return getBrandName() === brands.VwBedrijfswagens
}

const brandCodeToNameMap = {
  V: 'Volkswagen',
  N: 'Volkswagen Bedrijfswagens',
  S: 'SEAT/CUPRA',
  C: 'Skoda',
  A: 'Audi',
}

const brandCodeToUrlMap = {
  V: 'volkswagen',
  N: 'vwbedrijfswagens',
  S: 'seat',
  C: 'skoda',
  A: 'audi',
}

export const getBrandUrlByCode = (code) => {
  if (!code) return null
  return brandCodeToUrlMap[code.toUpperCase()] || null
}

export const getBrandNameByCode = (code) => {
  if (!code) return ''
  return brandCodeToNameMap[code.toUpperCase()] || code
}

/**
 * Classes for a badge that names a brand. It carries that brand's own colour
 * rather than the active skin's, so an Audi row stays Audi red while the app is
 * running Škoda — see the cross-brand palette in styles/ds/_tokens.scss.
 * '*' means "every brand".
 */
export const getBrandBadgeClass = (code) => {
  const modifier = code === '*' ? 'allBrands' : getBrandUrlByCode(code)
  return ['ds-badge', modifier && `ds-badge--${modifier}`].filter(Boolean)
}
